// extracted by mini-css-extract-plugin
module.exports = {"storePage":"home_storePage__3Py_g","main":"home_main__10PZp","container":"home_container__25qGo"};